import React from 'react'
import { useHistory } from 'react-router-dom'
import cn from 'classnames'

import SidebarModal from '../../SidebarModal'
import Button from '../../Button'

import styles from './More.module.scss'
import BackChevron from '../../BackChevron'

import OrderState from '../../../utils/orderStates'

const More = ({
  className,
  onClose,
  orderId,
  orderState,
  isMultiPayment,
}) => {

  const classNames = cn(styles.more, className)
  const history = useHistory()
  
  const handleViewReceipt = () => {
    const path = isMultiPayment ? `/tabs/${orderId}/receiptSelect` : `/receipt/${orderId}`
    history.replace(path)
  }

  // One can not actually get here via a closed order, but in case this changes in the future,
  // prevent the opportunity for a regression.
  const voidElement = (orderState) => {
    if (OrderState.isClosed(orderState)) {
      return null
    }

    return <Button key='void' onClick={() => history?.replace?.(`/tabs/${orderId}/void`)} className={styles.actionButton}>Void Items</Button>
  }

  return (
    <SidebarModal
      show
      title="More Options"
      onClose={onClose}
      leftAccessory={<BackChevron onClick={() => history?.replace?.(`/tabs/${orderId}`)} />}
      className={classNames}
    >
      <div className={styles.bodyContainer}>
        <div className={styles.buttonContainer}>
        {voidElement(orderState)}
        {!isMultiPayment && <Button key='adjustPrice' onClick={() => history?.replace?.(`/tabs/${orderId}/adjust-price`)} className={styles.actionButton}>Adjust Price</Button>}
        {/* {OrderStates.isOpen(orderState) && <Button key='adjustQuantities' onClick={() => history?.replace?.(`/tabs/${orderId}/adjust-quantities`)} className={styles.actionButton}>Adjust Quantities</Button>} */}
        <Button key='view receipt' onClick={handleViewReceipt} className={styles.actionButton}>View Receipt</Button>
        </div>
      </div>
    </SidebarModal>
  )
}

export default More
